
export const TEMATIC = 'tematikus';

function isMultipleCover(placeholders, backgroundType) {
  const placeholderslength = Object.keys(placeholders).length;
  return backgroundType !== TEMATIC && placeholderslength > 1;
}


export function canDropImageToPlaceholder(backgroundType, type, page) {
  const {
    isCover,
    placeholders,
  } = page;

  if ((backgroundType === TEMATIC || isMultipleCover(placeholders, backgroundType)) && !type && (isCover)) {
    return false;
  }
  return true;
}

export function DropLimitReached(maximumPicturesReached, isChange, ifIsFlyLeaf, activePage) {
  if (
    ((maximumPicturesReached) && !isChange) ||
    (ifIsFlyLeaf && Object.keys(activePage.droppedImages).length === 1)
  ) {
    return true;
  }
  return false;
}




// WEBPACK FOOTER //
// ./src/helpers/dropHelper.js